<template>
  <el-table-column
    prop="ntax_partner.store_in_txt"
    label="PARTNER.CSV-ben szerepel"
    width="250"
    sortable="custom"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      <el-tag
        v-if="!scope.row.ntax_partner || (scope.row.ntax_partner && scope.row.ntax_partner.store_in_txt === null)"
        size="small"
        type="warning"
      >
        Nincs megadva
      </el-tag>
      <el-tag
        v-if="scope.row.ntax_partner && scope.row.ntax_partner.store_in_txt === true"
        size="small"
        type="success"
      >
        Igen
      </el-tag>
      <el-tag
        v-if="scope.row.ntax_partner && scope.row.ntax_partner.store_in_txt === false"
        size="small"
        type="danger"
      >
        Nem
      </el-tag>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'ntax_partner.store_in_txt',
  };
</script>
